import { render, staticRenderFns } from "./sjDuty.vue?vue&type=template&id=0ff5d0a4&scoped=true&"
import script from "./sjDuty.vue?vue&type=script&lang=js&"
export * from "./sjDuty.vue?vue&type=script&lang=js&"
import style0 from "./sjDuty.vue?vue&type=style&index=0&id=0ff5d0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff5d0a4",
  null
  
)

export default component.exports